import { Controller } from 'stimulus'

// Results Summary section on a task's Results tab. The summary is built with
// the page; this keeps it in step with the grid above it by fetching the
// section body again, debounced, whenever results change: a remote form or
// link inside the tab succeeds (cell saves, row actions), a response says so
// outright (task-results:changed), or a broadcast reloads the grid
// (resourceable:reloaded). Pinned samples survive the swap.
const SETTLE_MS = 1200

export default class extends Controller {
  static targets = ['body'];

  connect() {
    this.onAjax = this.onAjax.bind(this)
    this.schedule = this.schedule.bind(this)
    document.addEventListener('ajax:success', this.onAjax)
    document.addEventListener('task-results:changed', this.schedule)
    document.addEventListener('resourceable:reloaded', this.schedule)
  }

  disconnect() {
    document.removeEventListener('ajax:success', this.onAjax)
    document.removeEventListener('task-results:changed', this.schedule)
    document.removeEventListener('resourceable:reloaded', this.schedule)
    clearTimeout(this.timer)
  }

  onAjax(event) {
    const tab = this.element.closest('.task-sections')
    if (!tab || !tab.contains(event.target) || this.element.contains(event.target)) { return }
    this.schedule()
  }

  schedule() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.load(), SETTLE_MS)
  }

  load() {
    fetch(this.data.get('url'), {
      credentials: 'same-origin',
      headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(response => (response.ok ? response.text() : Promise.reject(response)))
      .then((html) => {
        if (!this.hasBodyTarget) { return }
        this.bodyTarget.innerHTML = html
        const summary = this.application.getControllerForElementAndIdentifier(this.element, 'results-summary')
        if (summary) {
          summary.applyPins()
          summary.applyTrace(null)
          summary.renderTray()
        }
      })
      .catch(() => {})
  }
}
